/**
 * Filter duplicates from an array by equality.
 * Uses a Set internally.
 */
export const filterDuplicates = <T>(array: T[]): T[] =>
  Array.from(new Set(array));
